// src/utils/orgOrder.js
//
// The order organizations appear in the super-admin lists (the org cards, the
// org pickers). Firestore returns them by document id, which puts a demo org
// with a readable id ahead of a client with a generated one and otherwise
// means nothing. Here: organizations/{id}.listOrder first (a small number,
// set in the org editor; lower comes first), then the rest by name.

const orderOf = (org) => (typeof org?.listOrder === 'number' && Number.isFinite(org.listOrder) ? org.listOrder : Number.POSITIVE_INFINITY);

export const sortOrgs = (orgs = []) => [...orgs].sort((a, b) => {
    const d = orderOf(a) - orderOf(b);
    if (d !== 0) return d;
    return String(a?.name || '').localeCompare(String(b?.name || ''), 'en', { sensitivity: 'base' });
});
